export enum RouteErrorCode {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  NO_ROUTE_FOUND = 'NO_ROUTE_FOUND',
  NO_SUPPORTED_ROUTE = 'NO_SUPPORTED_ROUTE',
  TIMEOUT_EXCEEDED = 'TIMEOUT_EXCEEDED',
}
